module.exports = __webpack_public_path__ + "static/media/rulesTerms.1a50e965.svg";